// client/map/layers/index.ts
import type { LayerSpecification } from "maplibre-gl";
import { aircraft } from "./aircraft";
import { trails } from "./trails";
import { tracks } from "./tracks";
import { silos } from "./silos";
import { primitivesLayers } from "./primitives";
import { pdars } from "./pdars";
import { pdarAoaLines } from "./pdarAoaLines";
import { heatmap } from "./heatmap";

export const layers: LayerSpecification[] = [
  heatmap, // Bottom of the stack so markers/lines paint on top of the heat
  trails,
  tracks,
  aircraft,
  silos,
  ...primitivesLayers, // fill (bottom) + solid/dashed/dotted line layers
  pdarAoaLines, // 🌟 Moved up: Line vectors are written to the canvas first
  pdars, // Crisply overlays point icons on top of the vectors
];
